'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _bibShape = require('./bibShape');

var _bibShape2 = _interopRequireDefault(_bibShape);

var _branchShape = require('./branchShape');

var _branchShape2 = _interopRequireDefault(_branchShape);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reactImmutableProptypes2.default.mapContains({
  actions: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
  bib: _bibShape2.default,
  expiryDate: _react.PropTypes.string,
  holdPlacedDate: _react.PropTypes.string,
  holdsId: _react.PropTypes.string,
  holdsPosition: _react.PropTypes.number,
  itemId: _react.PropTypes.string,
  materialType: _react.PropTypes.string,
  metadataId: _react.PropTypes.string,
  pickupLocation: _branchShape2.default,
  status: _react.PropTypes.string
});


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/bc-prop-types/lib/components/holdItemShape.js
// module id = 298
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14